import ContentCarousel from './ContentCarousel';

export default ContentCarousel;
